// extracted by mini-css-extract-plugin
module.exports = {"input":"index-module--input--Srkhn","default":"index-module--default--3dTzt","form":"index-module--form--3CsOH"};